import ChevronRight from './icons/ChevronRight.jsx';
import Directions   from './icons/Directions.jsx';
import Phone        from './icons/Phone.jsx';
import Envelope     from './icons/Envelope.jsx';

const Icon = ({name}) => {
  switch (name) {
    case 'chevron-right':
      return <ChevronRight class="fill-white" height="12px" width="12px" />
    case 'directions':
      return <Directions class="fill-brown group-hover:fill-green" height="12px" width="12px" />
    case 'phone':
      return <Phone class="fill-brown group-hover:fill-green" height="12px" width="12px" />
    case 'envelope':
      return <Envelope class="fill-brown group-hover:fill-green" height="12px" width="12px" />
    default:
      return null;
  }
}

const Cta = ({ as = 'a', variant, icon, iconVariant, href, children, onClick, disabled, ...rest }) => {
  const As = as;
  if (variant === 'primary') {
    return (
      <As class="cursor-pointer bg-green hover:bg-rolexGreen text-white text-[14px] font-bold h-[44px] px-[30px] inline-flex justify-center items-center rounded-3xl disabled:opacity-50 disabled:cursor-not-allowed" href={href} onClick={onClick} disabled={disabled} {...rest}>
        <span>{children}</span> {icon && <ChevronRight class="ml-[6px] fill-white group-hover:fill-black" height="12px" width="12px"/>}
      </As>
    )
  }

  if (variant === 'secondary') {
    return (
      <As class="group cursor-pointer text-green hover:text-black group-hover:text-black text-[14px] font-bold inline-flex items-center" href={href} onClick={onClick} {...rest}>
        {children} <ChevronRight class="ml-[6px] fill-green group-hover:fill-black" height="12px" width="12px"/>
      </As>
    )
  }

  if (variant === 'round') {
    return (
      <As class="group cursor-pointer flex items-center" href={href} onClick={onClick} {...rest}><div class="mr-4 w-[40px] h-[40px] bg-lightBeige rounded-full flex justify-center items-center"><Icon name={iconVariant} /></div><span class="font-bold group-hover:text-green">{children}</span></As>
    )
  }

};

Cta.defaultProps = {
  variant: 'primary',
}

export default Cta;
